import React from 'react';
import { Trash2, RefreshCw } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from '@/components/ui/alert-dialog';

/* Diálogo de confirmación para borrados irreversibles (Admin) */
export const ConfirmDeleteDialog = ({ open, title, description, onCancel, onConfirm, loading = false, testId = 'confirm-delete-dialog' }) => (
  <AlertDialog open={open} onOpenChange={(v) => !v && !loading && onCancel()}>
    <AlertDialogContent className="bg-[#0D1520] border-[#1E3550] text-[#E2EAF4] z-[10001]" data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2 text-[#E2EAF4]">
          <Trash2 className="w-5 h-5 text-red-500" />
          {title}
        </AlertDialogTitle>
        <AlertDialogDescription className="text-[#5A7A9A]" data-testid={`${testId}-description`}>
          {description}
          <span className="block mt-2 text-red-400 font-medium">Esta acción no se puede deshacer.</span>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel
          disabled={loading}
          className="bg-transparent border-[#1E3550] text-[#E2EAF4] hover:bg-[#1E3550]"
          data-testid={`${testId}-cancel`}
        >
          Cancelar
        </AlertDialogCancel>
        <AlertDialogAction
          disabled={loading}
          onClick={(e) => { e.preventDefault(); onConfirm(); }}
          className="bg-red-600 hover:bg-red-700 text-white"
          data-testid={`${testId}-confirm`}
        >
          {loading ? <RefreshCw className="w-4 h-4 animate-spin" /> : 'Eliminar'}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ConfirmDeleteDialog;
